import "./about.css";
import { buildAboutContext, buildAboutItems } from "../../../Utils/buildContext";


function About({ lang }) {
  const context = buildAboutContext(lang);
  const items = buildAboutItems(lang)

  return (
    <section className="about" id="about">
      <div className="above">
        <h2>{context.title}</h2>
        <p>{context.desc_p}</p>
      </div>
      <div className="below">
        {items.map((item, index) => (
          <div className="about-item" key={index}>
            <h2>{item.title}</h2>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default About;